const MVSlide = new Swiper('#mainVisual .swiper', {
    loop: true,
    loopadditionalslides: 1,
    centeredSlides: true,
    slidesPerView: 1.3,
    spaceBetween: 20,
    speed: 1000,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        waitForTransition: true,
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    breakpoints: {
        992: {
            slidesPerView: 1.5,
            spaceBetween: 30,
        }
    },
});

const NewsSlide = new Swiper('#homeNews .swiper', {
    loop: false,
    navigation: {
        nextEl: '.news_box_next',
        prevEl: '.news_box_prev',
    }
});

const PFSlide = new Swiper('#homePerformance .swiper', {
    loop: false,
    slidesPerView: 'auto',
    freeMode: true,
    freeModeSticky: true,
    grabCursor: true,
    navigation: {
        nextEl: '.pf_next',
        prevEl: '.pf_prev',
    },
});